import { render, staticRenderFns } from "./detailFormOffline.vue?vue&type=template&id=7fd74d0c&scoped=true"
import script from "./detailFormOffline.vue?vue&type=script&lang=js"
export * from "./detailFormOffline.vue?vue&type=script&lang=js"
import style0 from "./detailFormOffline.vue?vue&type=style&index=0&id=7fd74d0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd74d0c",
  null
  
)

export default component.exports